import React from 'react'
import Link from 'next/link'
import { useTrans } from '@next-nx/hooks'
import { PlusLight } from '@next-nx/shared-ui/icons'
import { Button } from '@next-nx/shared-ui/atoms'
import styles from './ComparatoreCard.module.sass'
import { getAnchorRel } from '@next-nx/utils'

interface Props {
  url?: string
  className?: string
  handleTracking?: (t: string, e: string, cta: string) => void
}

const ComparatoreCard = (props: Props) => {
  const { url = '/', className = '', handleTracking = () => undefined } = props

  const t = useTrans()

  return (
    <Link href={url}>
      <a className={`${styles.root} ${className}`} rel={getAnchorRel(url)}>
        <div
          className={styles.plus}
          onClick={() =>
            handleTracking('aggiungi_prodotto', 'aggiunta_prodotto_comparatore', 'piu_comparatore')
          }
        >
          <PlusLight />
        </div>
        <Button
          label={t('Aggiungi veicolo')}
          labelMobile={t('Aggiungi')}
          onClick={() =>
            handleTracking(
              'aggiungi_prodotto',
              'aggiunta_prodotto_comparatore',
              'aggiungi_veicolo_comparatore'
            )
          }
        />
        <p className={styles.description}>
          {t('Clicca qui per aggiungere un veicolo alla selezione')}
        </p>
      </a>
    </Link>
  )
}

export default ComparatoreCard
